<template>
  <div class="newscard">
    <div class="picture">
      <a :href="content.url" target="_blank"><img :src="content.image"></a>
    </div>
    <h1 class="topic"><a :href="content.url" target="_blank">{{ content.topic }}</a></h1>
    <h3 class="categories"><a href="" @click.prevent="">{{ content.categories }}</a></h3>
    <p>{{ content.content }}</p>
    <h3 class="readmore"><a :href="content.url" target="_blank">
      閱讀文章 <i class="fas fa-angle-right"></i>
    </a></h3>
  </div>
</template>

<script>
export default {
  props: {
    newscard: {
      type: Object,
      default: () => ({
        topic: '這是標題',
        categories: '這是種類',
        content: '這是內容',
        image: 'https://picsum.photos/800/800?random=1',
        url: '',
      }),
    },
  },
  data() {
    return {
      content: this.newscard,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.newscard {
  max-width: 500px;
  margin: 10px;
  height: 100%;
  // margin-bottom: 10px;
  padding: 20px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: 0 0 5px rgba(170, 170, 170, 0.486);
  color: #222;
  text-align: justify;
  .picture{
    img{
      width: 100%;
      height: 200px;
      object-fit: cover;
    }
  }
  a{
    text-decoration: none;
    color: #222;
  }
  .topic {
    margin: 20px auto;

    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
  .topic:hover a{
    color: #640000;
  }
  .categories a{
    color: #999;
  }
  h1{
    font-size: 1.5rem;
  }
  h3{
    font-size: 1.2rem;
  }
  p {
    font-size: 1rem;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
  .readmore{
    display: flex;
    margin: 0;
    a{
      color: turquoise;
    }
    a:after {
    content: "";
    display: block;
    width: 0;
    height: 2px;
    margin: 10px 0;
    background-color:violet;
    transition: width 0.3s;
    }
  }
  .readmore:hover{
    a:after{
    width: 100%;
    }
  }
}
</style>
